<div class="container mt-3">
  <div class="row">
    <mat-form-field appearance="outline" class="col-md-4">
      <mat-label>Enter a date range</mat-label>
      <mat-date-range-input [rangePicker]="picker">
        <input matStartDate [(ngModel)]="startDate" placeholder="Start date">
        <input matEndDate [(ngModel)]="endDate" placeholder="End date" (dateChange)="onEndDateChanged()">
      </mat-date-range-input>
      <mat-hint>DD/MM/YYYY – DD/MM/YYYY</mat-hint>
      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-date-range-picker #picker></mat-date-range-picker>
    </mat-form-field>

    <mat-form-field appearance="outline" class="col-md-3">
      <mat-label>Select Centre</mat-label>
      <mat-select (selectionChange)="setSelectedCentreCode($event)" [(ngModel)]="selectedCentreCode">
        <mat-option value="All">All</mat-option>
        <mat-option *ngFor=" let c of (centres$|async) " [value]="c.centreCode">{{ c.centreName }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline" class="col-md-3">
      <mat-label>Select Occupation</mat-label>
      <mat-select [(ngModel)]="selectedOccupations" multiple (selectionChange)="applyClientSideFilters()">
        <mat-option *ngFor="let o of (occupations$|async)" [value]="o">{{ o }}</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline" class="col-md-3">
      <mat-label>Select Skill</mat-label>
      <mat-select [(ngModel)]="selectedSkills" multiple (selectionChange)="applyClientSideFilters()">
        <mat-option *ngFor="let s of (skills$|async)" [value]="s">{{ s }}</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline" class="col-md-3">
      <mat-label>Select Relation</mat-label>
      <mat-select [(ngModel)]="selectedRelations" multiple (selectionChange)="applyClientSideFilters()">
        <mat-option *ngFor="let r of (relations$|async)" [value]="r">{{ r }}</mat-option>
      </mat-select>
    </mat-form-field>

    <div class="col-md-2">
      <div class="d-flex justify-content-start">
        <button mat-mini-fab color="accent" (click)="dynamicQuery()" matTooltip="Search">
          <mat-icon>search</mat-icon>
        </button>
        <button mat-mini-fab color="accent" (click)="clearAll()" matTooltip="Clear" class="ms-2">
          <mat-icon>clear</mat-icon>
        </button>
      </div>
    </div>
  </div>

  <div class="card p-2">
    <div class="ngxTableHeader">
      <ul class="header-buttons-left ms-0 mb-0">
        <li class="dropdown">
          <h2>Guardian Report</h2>
        </li>
        <li class="dropdown m-l-20">
          <label for="search-input"><i class="material-icons search-icon">search</i></label>
          <input id="search-input" placeholder="Search" type="text" class="browser-default search-field"
                 (keyup)='applyFilter($event)' aria-label="Search box" #input>
        </li>
      </ul>
      <ul class="header-buttons mr-2">
        <li>
          <div class="export-button m-l-10" matTooltip="XLSX" (click)="downloadReport()" >
            <img src="assets/images/icons/xlsx.png" alt=""/>
          </div>
        </li>
      </ul>
    </div>

    <div class="row">
      <div class="note">Use this to generate custom reports or re-arrange columns</div>
      <mat-form-field class="col-md-12" appearance="outline">
        <mat-label>Columns</mat-label>
        <mat-select [value]="displayedColumns" (selectionChange)="onColumnsSelected($event)" multiple>
          <mat-option *ngFor="let o of dynamicColumns" [value]="o.value">{{ o.label }}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <mat-progress-bar *ngIf="isLoading" mode="indeterminate">Please wait Data is loading... </mat-progress-bar>

    <section class="example-container" tabindex="1">
      <table mat-table [dataSource]="dataSource" matSort id="guardian-table"
             class="guardian-table table table-striped table-bordered">

        <!-- Position Column -->
        <ng-container matColumnDef="position">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>#</th>
          <td mat-cell *matCellDef="let i = index">
            {{ this.paginator.pageIndex == 0 ? i + 1 : 1 + i + this.paginator.pageIndex * this.paginator.pageSize }}
          </td>
        </ng-container>

        <!-- Child First Name Column -->
        <ng-container matColumnDef="childFirstName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Child First Name</th>
          <td mat-cell *matCellDef="let element">{{element.childFirstName}}</td>
        </ng-container>

        <!-- Child Last Name Column -->
        <ng-container matColumnDef="childLastName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Child Last Name</th>
          <td mat-cell *matCellDef="let element">{{element.childLastName}}</td>
        </ng-container>

        <!-- Child Code Column -->
        <ng-container matColumnDef="childCode">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Child Code</th>
          <td mat-cell *matCellDef="let element">{{element.childCode}}</td>
        </ng-container>

        <!-- Centre Name Column -->
        <ng-container matColumnDef="centreName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Centre Name</th>
          <td mat-cell *matCellDef="let element">{{element.centreName}}</td>
        </ng-container>

        <!-- First Name Column -->
        <ng-container matColumnDef="firstName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Guardian First Name</th>
          <td mat-cell *matCellDef="let element">{{element.firstName}}</td>
        </ng-container>

        <!-- Middle Name Column -->
        <ng-container matColumnDef="middleName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Guardian Middle Name</th>
          <td mat-cell *matCellDef="let element">{{element.middleName}}</td>
        </ng-container>

        <!-- Last Name Column -->
        <ng-container matColumnDef="lastName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Guardian Last Name</th>
          <td mat-cell *matCellDef="let element">{{element.lastName}}</td>
        </ng-container>

        <!-- Relation Column -->
        <ng-container matColumnDef="relation">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Relation</th>
          <td mat-cell *matCellDef="let element">{{element.relation}}</td>
        </ng-container>

        <!-- Occupation Column -->
        <ng-container matColumnDef="occupation">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Occupation</th>
          <td mat-cell *matCellDef="let element">{{element.occupation}}</td>
        </ng-container>

        <!-- Contact Number Column -->
        <ng-container matColumnDef="contactNo">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Contact Number</th>
          <td mat-cell *matCellDef="let element">{{element.contactNo}}</td>
        </ng-container>

        <!-- Alternate Contact Column -->
        <ng-container matColumnDef="alternateContactNo">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Alternate Contact</th>
          <td mat-cell *matCellDef="let element">{{element.alternateContactNo}}</td>
        </ng-container>

        <!-- Skills Column -->
        <ng-container matColumnDef="skills">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Skills</th>
          <td mat-cell *matCellDef="let element">{{element.skills}}</td>
        </ng-container>

        <!-- Annual Income Column -->
        <ng-container matColumnDef="annualIncome">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Annual Income</th>
          <td mat-cell *matCellDef="let element">{{element.annualIncome}}</td>
        </ng-container>

        <!-- Aadhar Number Column -->
        <ng-container matColumnDef="aadharNumber">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Aadhar Number</th>
          <td mat-cell *matCellDef="let element">{{element.aadharNumber}}</td>
        </ng-container>

        <!-- Election ID Column -->
        <ng-container matColumnDef="electionId">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Election ID</th>
          <td mat-cell *matCellDef="let element">{{element.electionId}}</td>
        </ng-container>

        <!-- Ration Card Column -->
        <ng-container matColumnDef="rationCard">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Ration Card</th>
          <td mat-cell *matCellDef="let element">{{element.rationCard}}</td>
        </ng-container>

        <!-- Other Documents Column -->
        <ng-container matColumnDef="otherDocuments">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Other Documents</th>
          <td mat-cell *matCellDef="let element">{{element.otherDocuments}}</td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

        <!-- Row shown when there is no matching data. -->
        <tr class="mat-row" *matNoDataRow>
          <td class="mat-cell" colspan="4">No data matching the filter "{{input.value}}"</td>
        </tr>
      </table>
    </section>

    <mat-paginator [pageSizeOptions]="[25,50,100,200,250,500,1000]"
                   aria-label="Select page of guardians">
    </mat-paginator>
  </div>
</div>
